var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.datas.styleType == 2)?_c('div',{attrs:{"id":"follow"}},[_c('div',{staticClass:"follow-box",style:({
      background: _vm.datas.backColor,
      'border-style': _vm.datas.borderStyle,
      'border-color': _vm.datas.borderColor,
      'border-width': _vm.datas.borderLineWeight + 'px',
      'border-radius': _vm.datas.borderRadius + 'px',
      'padding-top': _vm.datas.paddingTop + 'px',
      'padding-bottom': _vm.datas.paddingBottom + 'px',
      'padding-left': _vm.datas.paddingLeft + 'px',
      'padding-right': _vm.datas.paddingRight + 'px',
      'margin-top': _vm.datas.marginTop + 'px',
      'margin-bottom': _vm.datas.marginBottom + 'px',
      'margin-left': _vm.datas.marginLeft + 'px',
      'margin-right': _vm.datas.marginRight + 'px',
    })},[[_c('div',{staticClass:"follow-info",style:({
          'font-size': _vm.datas.wordSize + 'px',
          'font-weight': _vm.datas.isBold ? 'bold' : 'normal',
          'font-style': _vm.datas.isTilt ? 'italic' : 'normal',
          'text-decoration': _vm.datas.isUnderLine ? 'underline' : 'none',
          color: _vm.datas.wordColor,
        })},[_vm._v(" "+_vm._s(_vm.datas.followDesc)+" ")]),_c('div',{staticClass:"follow-pic",on:{"click":_vm.handleShowPublicDialog}},[_c('img',{attrs:{"src":_vm.datas.btnImgUrl || _vm.defaultImg,"alt":""}})])]],2),_vm._t("deles"),_c('van-overlay',{attrs:{"show":_vm.showImgModal,"z-index":"5"}},[_c('div',{staticClass:"overlay_con"},[_c('div',{staticClass:"img_info_con"},[(_vm.datas['publicAccountUrl'])?_c('img',{staticClass:"full_img",attrs:{"src":_vm.datas['publicAccountUrl'],"alt":""}}):_c('p',[_vm._v("请在后台配置公众号图片")])]),_c('van-icon',{staticClass:"close_btn_con",attrs:{"name":"close","color":"#fff","size":"30"},on:{"click":function($event){_vm.showImgModal = false}}})],1)])],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }